module.exports = require("./fr-MC.js");